package dev.lingvo.site.components.editor

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import dev.lingvo.site.ds.ControlHeight
import dev.lingvo.site.ds.Radius
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.interactiveTransition
import dev.lingvo.site.ds.pressScale
import dev.lingvo.site.ds.pressTransition
import dev.lingvo.site.ds.toSitePalette
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

private val EDITOR_ASSIST_FINE_POINTER_QUERY =
    CSSMediaQuery.Raw("(hover: hover) and (pointer: fine)")

val EditorProviderSettingsLinkStyle = CssStyle {
    base {
        Modifier
            .minHeight(ControlHeight.MD)
            .padding(leftRight = Space.MD)
            .gap(Space.SM)
            .backgroundColor(colorMode.toSitePalette().surface)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderStrong)
            .borderRadius(Radius.Control)
            .color(colorMode.toSitePalette().textPrimary)
            .fontSize(TypeScale.Small)
            .fontWeight(600)
            .interactiveTransition()
            .styleModifier {
                property("display", "inline-flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("text-decoration", "none")
                property("width", "fit-content")
                property("max-width", "100%")
            }
    }
    cssRule(EDITOR_ASSIST_FINE_POINTER_QUERY, ":hover") {
        Modifier.backgroundColor(colorMode.toSitePalette().surfaceRaised)
    }
    cssRule(EDITOR_ASSIST_FINE_POINTER_QUERY, ":active") {
        Modifier.pressScale().pressTransition()
    }
    focusVisible {
        Modifier
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier { property("outline-offset", "2px") }
    }
}

/** Lets localized Assist actions wrap without overriding the design-system hit-area contract. */
internal fun Modifier.editorAssistWrappingAction(): Modifier = minHeight(ControlHeight.SM)
    .styleModifier { property("height", "auto") }
